<template>
    <div class="content-container compact-node">
        <div class="d-flex p-0 text-start align-items-center" @click="this.expanded = !this.expanded">
            <div class="container-icon arrow">
                <i :class="expanded ? 'bi bi-chevron-compact-down' : 'bi bi-chevron-compact-right'"></i>
            </div>
            <h6 class="m-0" style="line-height: 1.2;">{{ node.activeTitle }}</h6>
        </div>
        <ContentNode v-if="this.expanded" :id="node.id" :type="node.type" :title="node.activeTitle"
            :childrens="node.childrens" :key="node.activeTitle" :contentTree="this.contentTree" />
    </div>
</template>

<!--<style scoped>
.icon {
    width: 18px;
}
</style>-->

<script>

import ContentNode from './ContentNode.vue';

export default {
    name: 'ContainerNode',
    components: {
        ContentNode
    },
    data() {
        return {
            expanded: true,
            showModal: false,
            selectedArticleId: null,
            selectedVersionId: null,
        }
    },
    props: {
        node: {
            type: Object,
            required: true
        },
        contentTree: {
            type: Object,
            required: false
        }
    },
}

</script>

<style scoped>
.m-0 {
    line-height: 1.2;
    margin: 0.5rem !important;
}

.arrow {
    display: flex;
    align-items: flex-start;
    margin-right: 0.25rem;
}

.arrow svg {
    flex-shrink: 0;
    margin-right: 0.25rem;
    height: 1em;
    width: 1em;
}
</style>